import { Module } from 'vuex-smart-module';
import SubpartnersSalesActions from './actions';
import SubpartnersSalesGetters from './getters';
import SubpartnersSalesMutations from './mutations';
import SubpartnersSalesState from './state';

export default new Module({
  state: SubpartnersSalesState,
  mutations: SubpartnersSalesMutations,
  actions: SubpartnersSalesActions,
  getters: SubpartnersSalesGetters,
});
